import Swal from 'sweetalert2';
import { RemoteConstants } from '../../data/remote/RemoteConstants';
import { UIActions } from '../../presentation/redux/actions/UIActions';
import { errorManager } from '../../presentation/utils/errorManager';
import { getHorarios } from './getHorarios';


/* eslint-disable no-unused-vars */
export const saveHorarios = async (token, values, dispatch, usuario) => {
    try {
        const params = new URLSearchParams({
            token: token,
            uid: usuario,
            com_hf: values.com_hf,
            com_hi: values.com_hi,
            dom_hf: values.dom_hf,
            dom_hi: values.dom_hi,
            jue_hf: values.jue_hf,
            jue_hi: values.jue_hi,
            lun_hf: values.lun_hf,
            lun_hi: values.lun_hi,
            mar_hf: values.mar_hf,
            mar_hi: values.mar_hi,
            mie_hf: values.mie_hf,
            mie_hi: values.mie_hi,
            sab_hf: values.sab_hf,
            sab_hi: values.sab_hi,
            vie_hf: values.vie_hf,
            vie_hi: values.vie_hi
        });
        const peticion = await fetch(`${RemoteConstants.BASE_URL}pin/save-horarios?${params.toString()}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
            .then(resp => {
                return resp.json();
            })
            .then(data => {
                if (data.code === 'OK') {
                    Swal.fire('¡Hecho!', data.userMessage, 'success');
                    getHorarios(token, usuario, dispatch);
                } else {
                    errorManager(data.userMessage);
                }
            });
    } catch (error) {
        errorManager(error);
    }
    dispatch(UIActions.uiLoadInactive());
}